import React from 'react';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { RiErrorWarningLine } from 'react-icons/ri';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import { AiOutlineWarning } from 'react-icons/ai';
import classes from './AlertBlock.module.css';
import { AlertMessage } from '../../../types/alert';

interface AlertData {
  className: string;
  header: JSX.Element | null;
}

const AlertBlock: React.FC = () => {
  const alerts = useTypedSelector((state) => state.alert);

  return (
    <div className={classes.alertContainer}>
      {alerts.map((alert: AlertMessage) => {
        let data: AlertData = {
          className: '',
          header: null,
        };

        switch (alert.alertType) {
          case 'success':
            data.className = classes.alertMessageSuccess;
            data.header = (
              <p className={classes.alertMessageHeader}>
                <IoIosCheckmarkCircleOutline
                  className={classes.alertMessageSuccessIcon}
                />{' '}
                Success
              </p>
            );
            break;
          case 'error':
            data.className = classes.alertMessageError;
            data.header = (
              <p className={classes.alertMessageHeader}>
                <RiErrorWarningLine className={classes.alertMessageErrorIcon} />{' '}
                Error
              </p>
            );
            break;
          case 'warning':
            data.className = classes.alertMessageWarning;
            data.header = (
              <p className={classes.alertMessageHeader}>
                <AiOutlineWarning className={classes.alertMessageWarningIcon} />{' '}
                Warning
              </p>
            );
            break;
          default:
            break;
        }

        return (
          <div
            key={alert.id}
            className={`${classes.alertMessage} ${data.className}`}
          >
            {data.header}
            {alert.msg}
          </div>
        );
      })}
    </div>
  );
};

export default AlertBlock;
